const nykreditMarkerUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg role="presentation" width="23px" height="27px" viewBox="0 0 23 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'
    + '<title>Group 8</title>'
    + '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">'
    + '<g id="Find_kort_active" transform="translate(-844.000000, -976.000000)">'
    + '<g id="Group-8" transform="translate(844.000000, 976.000000)">'
    + '<path d="M22.5,0.5 L22.5,22.3461431 L15.6360039,22.3459953 L12.0226575,26.2626896 L8.40794026,22.3459959 L0.5,22.3461445 L0.5,0.5 L22.5,0.5 Z" id="Rectangle-7-Copy-2" stroke="#FFFFFF" fill="#0F1E82"></path>'
    + '<path d="M5.22727273,15.9652474 L5.24349469,6.3486392 C5.24349469,6.23791698 5.3573916,6.23076923 5.3573916,6.23076923 L10.405429,6.23076923 C10.5163421,6.22796992 10.5300677,6.33844754 10.5330515,6.33559387 L13.9543921,12.3483487 C13.9894307,12.4015084 14.069653,12.4287405 14.1331659,12.4043621 C14.1997478,12.3799836 14.2262613,12.2821436 14.2262613,12.2821436 L14.0828671,6.3557326 C14.0811621,6.28243416 14.0965075,6.24362431 14.1767298,6.23076923 L17.6279938,6.23076923 C17.763971,6.23076923 17.7759916,6.33265868 17.7721553,6.33004961 L17.7721553,15.932308 C17.7721553,15.932308 17.7562983,16.0600707 17.617252,16.0586846 L12.750205,16.0616455 C12.6385247,16.0616455 12.5470491,16.0600707 12.4430414,15.8990424 L9.05691001,9.8684318 C8.93073678,9.71449693 8.75417952,9.82790975 8.75417952,10.0006788 L8.94991852,15.9294543 C8.96364413,16.014249 8.88725817,16.064555 8.81308877,16.0586846 L5.34673508,16.0616455 C5.28296645,16.0629243 5.2243982,16.014249 5.22727273,15.9652474 L5.22727273,15.9652474 Z" id="Path-Copy-2" fill="#FFFFFF"></path>'
    + '</g>'
    + '</g>'
    + '</g>'
    + '</svg>')

const sparNordMarkerUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="30" height="39" viewBox="0 0 30 39" fill="none">
<rect width="29.2" height="38.4" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 15.4C25.5 15.4 27.4 15.7 29.2 16.4V0H0V38.5H7.6C6.9 36.6 6.5 34.6 6.5 32.5C6.5 23 14.1 15.4 23.5 15.4Z" fill="#BE3038"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M27.9 33.1C26.4 33.5 26.6 34.9 27.1 35.5C27.7 36.3 28.8 37.2 28.6 37.4C28.4 37.6 27.4 36.6 26.6 36.1C24.8 35 24.3 36.1 24.2 37.1C24.1 37.8 24.1 37.9 24.1 38.5H29.3V33C28.7 33 28.2 33 27.9 33.1Z" fill="#1E427E"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M24.8 29C25.3 29.3 25.9 29.1 26.4 28.8C27.3 28.2 27.6 28 27.7 28.1C27.8 28.2 27.4 28.6 27 29.3C26.3 30.6 26.8 31.3 27.8 31.7C28.2 31.8 28.7 31.8 29.2 31.9V19.1C27.4 18.3 25.5 17.9 23.5 17.9C15.5 17.9 9 24.4 9 32.4C9 34.6 9.5 36.6 10.3 38.4H22.9C22.9 38 22.9 37.6 22.8 37C22.8 35.9 22 35.1 20.5 36C19.5 36.6 18.6 37.6 18.4 37.4C18.2 37.2 19 36.5 19.9 35.4C20.9 34 19.8 33 18.5 32.9C15.6 32.6 14.1 32.6 14.1 32.3C14.1 32.1 16 32 18.6 31.7C20.1 31.6 20.8 30.4 19.8 29.1C19.2 28.3 18.2 27.4 18.4 27.2C18.6 27 19.3 27.8 20.3 28.5C21.1 29 21.6 29 22 28.9C22.5 28.7 22.7 28 22.7 27.7C23 25.3 23 20.5 23.4 20.5C23.8 20.5 23.9 24.8 24.2 27.7C24.3 28.5 24.5 28.8 24.8 29Z" fill="#1E427E"/>
</svg>`)

const tkMarkerUrl = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" role="presentation" viewBox="0 0 88 62"><g fill="none" fill-rule="evenodd"><path fill="#FF4D00" d="M38.276 19.714 24.785 33.137l5.97 5.94L44.242 25.66l13.487 13.418 5.967-5.938-13.49-13.422-5.967-5.936-5.963 5.933Z"/><path fill="#FF8300" d="M38.276 19.715 24.784 6.292 30.748.359l13.491 13.422zM44.24 13.782 57.731.359l5.963 5.933-13.491 13.423z"/></g></svg>')

export default {
    mixedTheme(designSchema = 'nykredit') {
        return {
            name: 'nykredit',
            markerDefault: (brand) => ({
                url: brand === 'nykredit' ? nykreditMarkerUrl : sparNordMarkerUrl,
                anchor: new window.google.maps.Point(11, 27),
                scaledSize: new window.google.maps.Size(23, 27)
            }),
            markerHighlight: (brand) => ({
                url: brand === 'nykredit' ? nykreditMarkerUrl : sparNordMarkerUrl,
                anchor: new window.google.maps.Point(17, 39),
                scaledSize: new window.google.maps.Size(34, 39)
            }),
            markerMedium: (brand) => ({
                url: brand === 'nykredit' ? nykreditMarkerUrl : sparNordMarkerUrl,
                anchor: new window.google.maps.Point(13, 30),
                scaledSize: new window.google.maps.Size(26, 30)
            }),
            markerMediumHighlight: (brand) => ({
                url: brand === 'nykredit' ? nykreditMarkerUrl : sparNordMarkerUrl,
                anchor: new window.google.maps.Point(19, 44),
                scaledSize: new window.google.maps.Size(38, 44)
            }),
            markerBig: (brand) => ({
                url: brand === 'nykredit' ? nykreditMarkerUrl : sparNordMarkerUrl,
                anchor: new window.google.maps.Point(15, 35),
                scaledSize: new window.google.maps.Size(30, 35)
            }),
            markerBigHighlight: (brand) => ({
                url: brand === 'nykredit' ? nykreditMarkerUrl : sparNordMarkerUrl,
                anchor: new window.google.maps.Point(22, 51),
                scaledSize: new window.google.maps.Size(44, 51)
            }),
            markerOptions: (brand) => ({
                animation: window.google.maps.Animation.DROP,
                zIndex: brand === designSchema ? 100 : 1
            }),
            mapOptions: {
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#68D2DF"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ]
            }
        }
    },
    totalkreditTheme() {
        return {
            name: 'totalkredit',
            markerDefault: () => ({
                url: tkMarkerUrl,
                anchor: new window.google.maps.Point(11, 27),
                scaledSize: new window.google.maps.Size(46, 54)
            }),
            markerHighlight: () => ({
                url: tkMarkerUrl,
                anchor: new window.google.maps.Point(17, 39),
                scaledSize: new window.google.maps.Size(68, 78)
            }),
            markerMedium: () => ({
                url: tkMarkerUrl,
                anchor: new window.google.maps.Point(13, 30),
                scaledSize: new window.google.maps.Size(52, 60)
            }),
            markerMediumHighlight: () => ({
                url: tkMarkerUrl,
                anchor: new window.google.maps.Point(19, 44),
                scaledSize: new window.google.maps.Size(76, 88)
            }),
            markerBig: () => ({
                url: tkMarkerUrl,
                anchor: new window.google.maps.Point(15, 35),
                scaledSize: new window.google.maps.Size(60, 70)
            }),
            markerBigHighlight: () => ({
                url: tkMarkerUrl,
                anchor: new window.google.maps.Point(22, 51),
                scaledSize: new window.google.maps.Size(88, 102)
            }),
            markerOptions: () => ({
                animation: window.google.maps.Animation.DROP
            }),
            mapOptions: {
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c9c9c9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ]
            }
        }
    }
}